// ignore-string-externalization
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import { jsx as _jsx } from "react/jsx-runtime";
var Backdrop = styled.div.withConfig({
  displayName: "Wait__Backdrop",
  componentId: "mdby55-0"
})(["", " width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.cover && "\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 10000;\n    background: white;\n  ";
});
export var Wait = function Wait(_ref) {
  var _ref$cover = _ref.cover,
      cover = _ref$cover === void 0 ? false : _ref$cover;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: {
      loadingIndicator: 'light'
    },
    children: /*#__PURE__*/_jsx(Backdrop, {
      "data-testid": "waiting",
      cover: cover,
      children: /*#__PURE__*/_jsx(LoadingIndicator, {})
    })
  });
};